<template>
  <div class="min-height">
    <TableLoading v-if="branch.publicId === ''"/>
    <div v-else>
      <form @submit.prevent="createOrder">
        <div class="row">
          <div class="col-sm-4">
            <div class="mb-3">
              <label>Ordered By</label>
              <input
                  v-model="order.orderedBy"
                  name="name"
                  type="text"
                  class="form-control py-3"
                  :class="{
                        'is-invalid': v$.order.orderedBy.$error,
                      }"
              />
              <p
                  v-for="error of v$.order.orderedBy.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="mb-3">
              <label>Delivery Date</label>
              <DatePicker v-model="deliveryDate" :disabled-dates="disabledDates" format="yyyy-MM-dd"></DatePicker>
              <p
                  v-for="error of v$.deliveryDate.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="mb-3">
              <label>Timezone</label>
              <multiselect v-model="order.orderTimezone" :options="availableTimezones" :class="{
                        'is-invalid': v$.order.orderTimezone.$error,
                  }" class="multiselect-height-3" placeholder="Select one" label="timezoneName" track-by="timezoneName"></multiselect>
              <p
                  v-for="error of v$.order.orderTimezone.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="mb-3">
              <label>LPO</label>
              <input
                  v-model="order.lpo"
                  name="name"
                  type="text"
                  class="form-control py-3"
                  :class="{
                        'is-invalid': v$.order.lpo.$error,
                      }"
              />
              <p
                  v-for="error of v$.order.lpo.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>
          <div class="row"  v-for="(p, r) in order.items" :key="r">
            <div class="mb-3 col-sm-4">
              <label>Product</label>
              <multiselect
                  v-model="order.items[r].itemId" :options="products_to_order"  class="multiselect-height-3"
                  placeholder="Select one" label="productName" track-by="productName" :searchable="true">
                <span slot="noResult">No product found. Change search query.</span>
              </multiselect>
            </div>
            <div class="mb-3 col-sm-4">
              <label>Quantity</label>
              <input
                  v-model="order.items[r].itemCount"
                  type="number"
                  class="form-control py-3"
              />
            </div>
            <div class="mb-3 col-sm-3 form-group align-self-end">
              <button
                  class="btn rounded-circle btn-dark mx-2"
                  v-if="r > 0"
                  @click.prevent="removeProducts(order.items, r)"
              >
                <i class="bx bx-minus"></i>
              </button>
              <button
                  class="btn rounded-circle btn-primary mx-2"
                  v-if="r == order.items.length - 1"
                  @click.prevent="addProducts(order.items)"
              >
                <i class="bx bx-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div v-for="(error, index) in ordersErrors" :key="index" style="color: #D13704;">
          {{error.message}}
        </div>
        <div class="mt-3 align-middle">
          <b-button variant="primary" size="lg" class="py-3 h3 w-100" disabled v-if="ordersLoading">
            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Loading
          </b-button>
          <b-button variant="primary" size="lg" class="py-3 h3 text-white w-100" type="submit" v-else>
            Create Customer Order
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import Multiselect from 'vue-multiselect'
import {SIMPLE_SINGLE_CUSTOMER_BRANCH} from "@/gql";
import {mapGetters, mapActions} from "vuex";
import moment from 'moment'
import DatePicker from '@sum.cumo/vue-datepicker'
import '@sum.cumo/vue-datepicker/dist/Datepicker.css'
import TableLoading from "@/components/TableLoading";

export default {
name: "customer-create-order-form-component",
  setup () {
    return { v$: useVuelidate() }
  },
  components: {
    TableLoading,
    Multiselect, DatePicker
  },
  data(){
    return{
      order:{
        customer: "",
        orderedBy: "",
        deliveryDate: "",
        lpo: "",
        orderTimezone: "",
        items: [{ itemId: "", warehouseId: "" , itemCount: ""}]
      },
      deliveryDate: "",
      longi: "",
      lat: "",
      products_to_order: [],
      disabledDates: {
        days: [],
        to: new Date(moment().format('YYYY-MM-DD'))
      },
      branch: {
        publicId: ''
      },
      availableTimezones: [],
      productSearchKeyword: "",
      outletId: JSON.parse(localStorage.getItem('activeUser')).outletId
    }
  },
  validations () {
    return {
      order:{
        orderedBy: {required},
        lpo: {required},
        orderTimezone: {required},
      },
      deliveryDate: {required},
    }
  },
  apollo: {
    branch: {
      query: SIMPLE_SINGLE_CUSTOMER_BRANCH,
      variables(){
        return {
          id: this.outletId.publicId
        }
      }
    }
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading',
      ordersErrors: 'orders/ordersErrors'
    }),
  },
  watch: {
    branch(){
      this.customerChange()
    },
    deliveryDate(){
      this.checkOrderTimezones()
    }
  },
  methods: {
  ... mapActions({
    checkAvailableTimezone: "orders/checkAvailableTimezone"
  }),
    async createOrder() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const new_items = []
      this.order.items.forEach((item) => {
        new_items.push({'itemId': item.itemId.publicId, 'itemCount': parseInt(item.itemCount), 'warehouseId': ''})
      })
      const data = {
        ...this.order,
        customer: this.outletId.publicId,
        orderTimezone: this.order.orderTimezone.publicId,
        deliveryDate: moment(this.deliveryDate).format('YYYY-MM-DD'),
        ignoreTimezoneLimit: false,
        items: new_items
      }
      this.$emit('orderAction', data)
      this.v$.$touch();
    },
    removeProducts(p, i) {
      p.splice(i, 1);
    },
    addProducts(p) {
      p.push({ itemId: "", warehouseId: "" , itemCount: ""});
    },
    addRecommendedProducts(){
      this.order.items.push({ itemId: { "value": "6", "label": "goal" }, warehouseId:  { "value": "1", "label": "KEA Trading LTD" } , itemCount: 67});
    },
    asyncFindProduct (query) {
      this.productSearchKeyword = query
    },
    customerChange(){
      this.order.customer = this.outletId.publicId
      this.products_to_order = this.branch.validOrderProducts
      this.longi = this.branch.longi
      this.lat = this.branch.lat

      // get days to remove from date picker
      const days = [0,1,2,3,4,5,6,7]
      this.branch.validOrderDays.forEach((day) =>{
        const index = days.indexOf(day.calendarCode);
        if (index > -1) {
          days.splice(index, 1);
        }
      })
      this.disabledDates.days = days

      this.checkOrderTimezones()
    },
    async checkOrderTimezones(){
      if (this.longi !== "" && this.deliveryDate !== ""){
        const data = {
          deliveryDate: moment(this.deliveryDate).format('YYYY-MM-DD'),
          long: parseInt(this.longi),
          lat: parseInt(this.lat)
        }
        await this.checkAvailableTimezone(data).then(resp => {
          this.availableTimezones = resp
        })
      }
    },
  },
}
</script>

<style scoped>

</style>
